import { render, staticRenderFns } from "./BusinessLogo.vue?vue&type=template&id=0975a72e&"
import script from "./BusinessLogo.vue?vue&type=script&lang=js&"
export * from "./BusinessLogo.vue?vue&type=script&lang=js&"
import style0 from "./BusinessLogo.vue?vue&type=style&index=0&id=0975a72e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports